import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n'
import router from '@/router';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { VISIBLE_PAGES } from '@/constants/labels';

/********************************
 ********** COMPONENTES *********
 *******************************/
import LangAndMenu from '@/components/PrincipalComponents/LangAndMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const { t } = useI18n()

/********************************
 ************ ROUTER ************
 *******************************/
const toggle_one = ref(0)

const VISUAL_OBJ:any = {
    0 : VISIBLE_PAGES.raosinit,
    1 : VISIBLE_PAGES.raosstatus,
    2 : VISIBLE_PAGES.raosmap,
    3 : VISIBLE_PAGES.raoskpi,
    4 : VISIBLE_PAGES.raosmng,
    5 : VISIBLE_PAGES.raosreport,
}

watch(toggle_one,(val:number) => {
    changeView(VISUAL_OBJ[val])
})


const changeView = (viewPage: string) => {
  router.push(`/smartlinkRAOS/${viewPage}`)
}

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: "ma-0 px-4",
    justify: "space-between"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        color: "transparent",
        class: "mt-4"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "textappBAR" }, " SMARTLINK RAOS ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_btn_toggle, {
        modelValue: toggle_one.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toggle_one).value = $event)),
        mandatory: "",
        class: "mt-2",
        color: "btnSelectBar",
        "base-color": "background"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('title.home')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('title.status')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('title.location')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" KPI ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('title.admin')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('title.report')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(LangAndMenu)
    ]),
    _: 1
  }))
}
}

})